import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared';
import { BlocksModule } from '../blocks/blocks.module';
import { MailsBoxService } from './mails-box.service';
import { MailsBoxComponent } from './mails-box.component';
import { MailsListBoxComponent } from './mails-list-box.component';
import { FastSearchModule } from '../blocks/ui-component/fast-search/fast-search.module';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        SharedModule,
        BlocksModule,
        ReactiveFormsModule,
        FastSearchModule
    ],
    declarations: [
        MailsBoxComponent,
        MailsListBoxComponent
    ],
    exports: [
        MailsBoxComponent
    ],
    providers: [
        MailsBoxService
    ]
})

export class MailsboxModule { }






